import { ReactNode } from 'react';
import { IntlProvider, useIntl as useReactIntl } from 'react-intl';
import { messages, Locale, defaultLocale } from '../lang';
import { useCountry, ECountry } from './CountryContext';

type TIntlContextProviderProps = {
  children: ReactNode;
};

export const getLocaleFromCountry = (country: ECountry): Locale => {
  switch (country) {
    case ECountry.Brasil:
      return 'pt-BR';
    case ECountry.Portugal:
      return 'pt-PT';
    case ECountry.Uruguai:
      return 'es-UY';
    case ECountry.Espanha:
      return 'es-UY';
    case ECountry.Estados_Unidos:
      return 'en-US';
    case ECountry.Argentina:
      return 'es-UY';
    default:
      return defaultLocale;
  }
};

export const getLocaleFromStorage = (): Locale => {
  const selectedCountry = localStorage.getItem("selectedCountry") as ECountry;
  return getLocaleFromCountry(selectedCountry);
};

export function IntlContextProvider({ children }: TIntlContextProviderProps) {
  const { country } = useCountry();
  const locale = getLocaleFromCountry(country);

  return (
    <IntlProvider
      locale={locale}
      messages={messages[locale]}
      defaultLocale={defaultLocale}
    >
      {children}
    </IntlProvider>
  );
}

export const useIntl = useReactIntl;
